export const drumBank = {
  bank1: {
    sounds: [
      {
        id: 0,
        link: './audio/bank1/Heater-1.mp3',
        description: 'heater 1',
      },
      {
        id: 1,
        link: './audio/bank1/Heater-2.mp3',
        description: 'heater 2',
      },
      {
        id: 2,
        link: './audio/bank1/Heater-3.mp3',
        description: 'heater 3',
      },
      {
        id: 3,
        link: './audio/bank1/Bld_H1.mp3',
        description: 'Closed Hat',
      },
      {
        id: 4,
        link: './audio/bank1/Kick_n_Hat.mp3',
        description: 'Kick-n-Hat',
      },
      {
        id: 5,
        link: './audio/bank1/side_stick_1.mp3',
        description: 'Side Stick',
      },
      {
        id: 6,
        link: './audio/bank1/Chord_1.mp3',
        description: 'Chord 1',
      },
      {
        id: 7,
        link: './audio/bank1/Chord_2.mp3',
        description: 'Chord 2',
      },
      {
        id: 8,
        link: './audio/bank1/Chord_3.mp3',
        description: 'Chord 3',
      },
    ],
  },
  bank2: {
    sounds: [
      {
        id: 0,
        link: './audio/bank2/BrightCrash01.mp3',
        description: 'Bright Crash',
      },
      {
        id: 1,
        link: './audio/bank2/ClosedHat01.mp3',
        description: 'Closed Hat',
      },
      {
        id: 2,
        link: './audio/bank2/MidOpenHat01.mp3',
        description: 'Open Hat',
      },
      {
        id: 3,
        link: './audio/bank2/CymbalChoke01.mp3',
        description: 'Cymbal Choke',
      },
      {
        id: 4,
        link: './audio/bank2/RideCymbal01.mp3',
        description: 'Ride Cymbal',
      },
      {
        id: 5,
        link: './audio/bank2/StereoHiTom01.mp3',
        description: 'HiTom',
      },
      {
        id: 6,
        link: './audio/bank2/StereoKick01.mp3',
        description: 'Kick',
      },
      {
        id: 7,
        link: './audio/bank2/StereoMidTom01.mp3',
        description: 'MidTom',
      },
      {
        id: 8,
        link: './audio/bank2/StereoSnare01.mp3',
        description: 'Snare',
      },
    ],
  },
  bank3: {
    sounds: [
      {
        id: 0,
        link: './audio/bank3/Oneshot-13.mp3',
        description: 'Oneshot 1',
      },
      {
        id: 1,
        link: './audio/bank3/Oneshot-15.mp3',
        description: 'Oneshot 2',
      },
      {
        id: 2,
        link: './audio/bank3/Oneshot-17.mp3',
        description: 'Oneshot 3',
      },
      {
        id: 3,
        link: './audio/bank3/Oneshot-33.mp3',
        description: 'Oneshot 4',
      },
      {
        id: 4,
        link: './audio/bank3/Oneshot-50.mp3',
        description: 'Oneshot 5',
      },
      {
        id: 5,
        link: './audio/bank3/Oneshot-51.mp3',
        description: 'Oneshot 6',
      },
      {
        id: 6,
        link: './audio/bank3/Oneshot-88.mp3',
        description: 'Oneshot 7',
      },
      {
        id: 7,
        link: './audio/bank3/Oneshot-89.mp3',
        description: 'Oneshot 8',
      },
      {
        id: 8,
        link: './audio/bank3/Oneshot-101.mp3',
        description: 'Oneshot 9',
      },
    ],
  },
  bank4: {
    sounds: [
      {
        id: 0,
        link: './audio/bank4/TonalSynth-033.mp3',
        description: 'TonalSynth 1',
      },
      {
        id: 1,
        link: './audio/bank4/TonalSynth-071.mp3',
        description: 'TonalSynth 2',
      },
      {
        id: 2,
        link: './audio/bank4/TonalSynth-072.mp3',
        description: 'TonalSynth 3',
      },
      {
        id: 3,
        link: './audio/bank4/TonalSynth-073.mp3',
        description: 'TonalSynth 4',
      },
      {
        id: 4,
        link: './audio/bank4/TonalSynth-074.mp3',
        description: 'TonalSynth 5',
      },
      {
        id: 5,
        link: './audio/bank4/TonalSynth-088.mp3',
        description: 'TonalSynth 6',
      },
      {
        id: 6,
        link: './audio/bank4/Start-Stop-16.mp3',
        description: 'Start-Stop 1',
      },
      {
        id: 7,
        link: './audio/bank4/Start-Stop-26.mp3',
        description: 'Start-Stop 2',
      },
      {
        id: 8,
        link: './audio/bank4/SubFX-7.mp3',
        description: 'SubFX',
      },
    ],
  },
};
